import type { InputHTMLAttributes, ReactElement } from "react";
import styles from "./TextInput.module.css";

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  mono?: boolean;
}

export function TextInput({
  invalid = false,
  mono = false,
  className,
  ...rest
}: TextInputProps): ReactElement {
  const cls = [
    styles.input,
    invalid ? styles.invalid : "",
    mono ? styles.mono : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return <input className={cls} aria-invalid={invalid || undefined} {...rest} />;
}
